var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f57c00;}.cls-2{fill:#999;}.cls-3{fill:#666;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "outline color",
    id: "outline_color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47,60H35a1,1,0,0,1-1-1V35a1,1,0,0,1,1-1H47a1,1,0,0,1,1,1V59A1,1,0,0,1,47,60ZM36,58H46V36H36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58,60H47a1,1,0,0,1-1-1V38a1,1,0,0,1,1-1H58a1,1,0,0,1,1,1V59A1,1,0,0,1,58,60ZM48,58h9V39H48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41,44a3,3,0,1,1,3-3A3,3,0,0,1,41,44Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,41,40Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44,60H38a1,1,0,0,1-1-1V54.29A3.3,3.3,0,0,1,40.29,51h1.42A3.3,3.3,0,0,1,45,54.29V59A1,1,0,0,1,44,60Zm-5-2h4V54.29A1.29,1.29,0,0,0,41.71,53H40.29A1.29,1.29,0,0,0,39,54.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54,56H51a1,1,0,0,1-1-1V50a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1v5A1,1,0,0,1,54,56Zm-2-2h1V51H52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54,48H51a1,1,0,0,1-1-1V42a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1v5A1,1,0,0,1,54,48Zm-2-2h1V43H52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41,36a1,1,0,0,1-1-1V29a1,1,0,0,1,2,0v6A1,1,0,0,1,41,36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46,33H41a1,1,0,0,1-1-1V29a1,1,0,0,1,1-1h5a1,1,0,0,1,1,1v3A1,1,0,0,1,46,33Zm-4-2h3V30H42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59,39H47a1,1,0,0,1,0-2H59a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35,60H23a1,1,0,0,1-1-1V38a1,1,0,0,1,1-1H35a1,1,0,0,1,1,1V59A1,1,0,0,1,35,60ZM24,58H34V39H24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31,56H27a1,1,0,0,1-1-1V50a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v5A1,1,0,0,1,31,56Zm-3-2h2V51H28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31,48H27a1,1,0,0,1-1-1V42a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v5A1,1,0,0,1,31,48Zm-3-2h2V43H28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35,39H22a1,1,0,0,1,0-2H35a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19,54a1,1,0,0,1-.69-.27,5.19,5.19,0,0,1-1.11-1.57L4.56,23.83a5,5,0,0,1,2.52-6.6l20.17-9A1,1,0,0,1,28.07,10l-20.17,9a3,3,0,0,0-1.52,4L19,51.32a3,3,0,0,0,.67.94A1,1,0,0,1,19,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.74,22.68a1,1,0,0,1-.92-.6,1,1,0,0,1,.51-1.32l8.21-3.67a1,1,0,1,1,.82,1.83l-8.22,3.67A1,1,0,0,1,16.74,22.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.44,29.38A1,1,0,0,1,16,27.47l6.78-3a1,1,0,0,1,.82,1.82l-6.78,3A1,1,0,0,1,16.44,29.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.89,34.85a1,1,0,0,1-.41-1.91l2.29-1a1,1,0,0,1,.82,1.82l-2.29,1A1,1,0,0,1,18.89,34.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.86,35a.78.78,0,0,1-.26,0,1,1,0,0,1-.7-1.22L27,7.67a5,5,0,0,1,6.14-3.51L56.31,10.5a4.9,4.9,0,0,1,3,2.33,5,5,0,0,1,.49,3.8L55,34.26a1,1,0,0,1-1.23.7,1,1,0,0,1-.7-1.22L57.9,16.11a3,3,0,0,0-.29-2.28,2.94,2.94,0,0,0-1.82-1.4L32.65,6.08A3,3,0,0,0,29,8.2L21.83,34.26A1,1,0,0,1,20.86,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.46,17.36a1.24,1.24,0,0,1-.27,0L38.51,15a1,1,0,0,1-.7-1.23A1,1,0,0,1,39,13l8.68,2.38a1,1,0,0,1-.26,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.77,23.94a1.24,1.24,0,0,1-.27,0L34,20A1,1,0,1,1,34.56,18L49,22a1,1,0,0,1-.26,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37,26.94a.78.78,0,0,1-.26,0l-4.29-1.17A1,1,0,0,1,33,23.81L37.26,25A1,1,0,0,1,38,26.2,1,1,0,0,1,37,26.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37,33.17a.75.75,0,0,1-.26,0l-5.87-1.61a1,1,0,1,1,.52-1.92l5.87,1.61a1,1,0,0,1,.7,1.22A1,1,0,0,1,37,33.17Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearch);
export default __webpack_public_path__ + "static/media/research.e393b1cca1e70247d38fbbad32aec685.svg";
export { ForwardRef as ReactComponent };